module.exports = __webpack_public_path__ + "static/media/Calibre-MediumItalic.3df14639.woff2";